module.exports = __webpack_public_path__ + "static/media/illustration-bem-estar.6e7651cb.svg";